// サマリー 検索テキスト
import ConvertStatus from '@/constants/convert_status.js'
export default {
  computed: {
    search: {
      get() {
        return this.$store.getters['SearchProperty/getSearch']
      },
      set(val) {
        this.$store.commit('SearchProperty/setSearch', val)
      },
    },
    selectSummaryText: {
      get() {
        return this.$store.getters['ConvertSummary/getSelectSummaryText']
      },
      set(val) {
        this.$store.commit('ConvertSummary/setSelectSummaryText', val)
      },
    },
  },
  methods: {
    // サマリー検索テキストを生成する
    summarySearchText(shopId) {
      let text = ''
      const searchSummary = this.search.summary
      const convertStatus = ConvertStatus
      const summarySearchType = this.search.summary_type
      const summarySearchTypeText = summarySearchType === 'or' ? 'もしくは' : 'かつ'
      const summaryData = this.$store.getters['ConvertSummary/getSummary']

      _.forEach(summaryData, function(data) {
        const searchObj = {
          cd: data.cd,
          shop_id: shopId,
        }
        const selectAry = _.filter(searchSummary, searchObj)
        let convertText = ''
        _.forEach(selectAry, function(select) {
          const convertSearchObj = {
            value: select.type,
          }
          const convertObj = _.find(convertStatus, convertSearchObj)
          convertText += `${convertObj['label']}${summarySearchTypeText}`
        })
        convertText = convertText.replace(/もしくは$/, '')
        convertText = convertText.replace(/かつ$/, '')
        if (convertText) {
          text += `${data.portal_site}${convertText}、`
        }
      })
      text = text.replace(/、$/, '')
      this.$set(this.selectSummaryText, shopId, text)
    },
  },
}
